export default "__VITE_ASSET__BjIw$NVl__"